let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kVX56"), load("76n7a"), load("l253H"), load("8YM4r")]).then(() => parcelRequire('6tZJD'));